<template>
  <div
    class="image-text-adv"
    :style="[{
      marginLeft: ($$FormData.page_edge ) * 0.5 + 'px',
      marginRight: ($$FormData.page_edge ) * 0.5 + 'px',
      borderRadius: ($$FormData.page_radius ) * 0.5 + 'px',
    }, $$FormData.show_background_style && $$FormData.background_style === 'image' ? {backgroundImage: `url(${$$FormData.background_image})`} : {backgroundColor: `${$$FormData.background_color}`}]"
  >
    <div class="title-text">
      <div
        class="title-text__content"
        :class="[
        `title-text__${$$FormData.position}`,
        {'title-text__bottom-slicer': $$FormData.show_bottom_slicer},
        `title-text__more-style${$$FormData.more_style}`
      ]"
      >
        <div class="title-text__body">
          <p
            class="title-text__title"
            :style="{
            fontSize: ($$FormData.title_font_size ) * 0.5 + 'px',
            fontWeight: $$FormData.title_font_weight,
            color: $$FormData.title_color
          }"
          >{{ $$FormData.title || '' }}</p>
          <p
            v-if="$$FormData.sub_title"
            class="title-text__sub-title"
            :style="{
            fontSize: ($$FormData.sub_title_font_size ) * 0.5 + 'px',
            fontWeight: $$FormData.sub_title_font_weight,
            color: $$FormData.sub_title_color
          }"
          >
            {{ $$FormData.sub_title || '' }}
          </p>
        </div>
        <div v-if="$$FormData.show_more" class="title-text__more" :style="{ color: $$FormData.more_color }">
          <span v-if="$$FormData.more_style !== 3" class="title-text__more-text">{{ $$FormData.more_text }}</span>
          <i v-if="$$FormData.more_style !== 1" class="title-text__more-arrow ri-arrow-right-s-line" />
        </div>
      </div>
    </div>
    <div class="image-list" v-if="$$FormData.content_type === 'image' && $$FormData.imageList.length">
      <div
        v-for="item in $$FormData.imageList"
        :key="item.__key"
        class="image-text-nav__item">
        <div
          class="image-text-nav__image"
          :style="{
            backgroundImage: `url(${item.image.src})`
          }"
        />
      </div>
    </div>
    <div class="goods-preview" v-if="$$FormData.content_type === 'goods' && $$FormData.goodsList.length">
      <ul
        class="goods-preview__list"
        :class="$$FormData.list_style"
        :style="{
          marginLeft: (-($$FormData.goods_space / 2) ) * 0.5 + 'px',
          marginRight: (-($$FormData.goods_space / 2) ) * 0.5 + 'px'
        }">
        <li
          v-for="(item, itemIndex) in $$FormData.goodsList"
          :key="itemIndex"
          class="item-goods"
        >
          <div
            class="a-item-goods"
            :style="{margin: ($$FormData.goods_space / 2 ) * 0.5 + 'px', backgroundColor: $$FormData.goods_background_color, borderColor: $$FormData.goods_border_color}"
            :class="[$$FormData.goods_chamfer, $$FormData.goods_style]"
          >
            <div class="image-goods">
              <div class="image-goods-inner" :style="{paddingTop: imagePaddingTopByRatio}">
                <div
                  class="img-goods"
                  :class="[$$FormData.image_fill]"
                  :style="{backgroundImage: `url(${item.thumbnail})`}"
                ></div>
              </div>
            </div>
            <div class="info-goods">
              <div class="title-goods">
                <h3  v-if="$$FormData.show_goods_name" class="name-goods">{{ item.goods_name }}</h3>
                <p v-if="$$FormData.show_goods_specs" class="specs-goods">
                  {{ item.specs_name || getSkuList(item.specs) }}
                </p>
              </div>
              <div class="price-goods">
                <div v-if="$$FormData.show_goods_price" class="price" :style="{fontWeight: $$FormData.text_font_weight}">
                  <span class="currency-price">￥</span>
                  <span class="money-price">{{ item.price }}</span>
                  <span v-if="$$FormData.show_goods_original_price && item.mktprice" class="original-price">￥{{ item.mktprice }}</span>
                </div>
                <div v-if="$$FormData.show_goods_buy_btn" class="buy-btn" :class="['style-' + $$FormData.goods_buy_btn_style]">
                  <i v-if="$$FormData.goods_buy_btn_style === 1" class="van-icon van-icon-cart-circle-o"></i>
                  <i v-if="$$FormData.goods_buy_btn_style === 2" class="van-icon van-icon-add-o"></i>
                  <i v-if="$$FormData.goods_buy_btn_style === 5" class="van-icon van-icon-add"></i>
                  <i v-if="$$FormData.goods_buy_btn_style === 6" class="van-icon van-icon-shopping-cart-o"></i>
                  <img v-if="$$FormData.goods_buy_btn_style === 10" class="buy-btn-image" :src="$$FormData.buy_btn_style_image" :alt="$$FormData.buy_btn_style_image">
                  <button v-else-if="$$FormData.goods_buy_btn_text" class="buy-text">
                    {{ $$FormData.goods_buy_btn_text }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="$$FormData.show_goods_badge" class="badge-goods" :class="$$FormData.goods_badge_style">
              <i v-if="$$FormData.goods_badge_style === 'new'" class="van-icon van-icon-new-arrival"></i>
              <i v-else-if="$$FormData.goods_badge_style === 'hot'" class="van-icon van-icon-hot-sale"></i>
              <i v-else-if="$$FormData.goods_badge_style === 'NEW'" class="van-icon van-icon-new"></i>
              <i v-else-if="$$FormData.goods_badge_style === 'HOT'" class="van-icon van-icon-hot"></i>
              <img
                v-else-if="$$FormData.goods_badge_style_image"
                :src="$$FormData.goods_badge_style_image"
                :alt="$$FormData.goods_badge_style_image"
                class="image-badge"
              >
              <div v-else class="image-badge no-image">
                <p>角标</p>
                <p>区域</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageTextAdvPreview',
  computed: {
    /**
     * 通过图片比例计算paddingTop
     * @returns {string}
     */
    imagePaddingTopByRatio() {
      switch (this.$$FormData.image_ratio) {
        case '3:2': return '66.6667%';
        case '1:1': return '100%';
        case '3:4': return '133.333%';
        case '16:9': return '56.25%';
        case '1.9:1': return '52.63%';
      }
      return '66.6667%'
    }
  },
  methods: {
    /** 获取规格列表 */
    getSkuList(val) {
      const _val = typeof val === 'string' ? JSON.parse(val) : val
      if (_val) {
        let _specs = []
        _val.forEach(elem => {
          _specs.push(elem.spec_value)
        })
        _specs = _specs.join('/')
        return _specs
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.image-text-adv {
  padding: 10px;
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title-text {
  display: block;
  width: 100%;
  padding: 0 10px;
  color: #333333;
  min-height: 30px;
  background: transparent;
  text-decoration: none;
  box-sizing: border-box;
  .title-text__content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.title-text__center {
      display: flex;
      flex-direction: column-reverse;
      align-items: center;
      text-align: center;
      .title-text__more {
        margin: 8px 0;
        float: none;
      }
    }
    .title-text__body {
      display: flex;
      align-items: center;
      justify-items: center;
    }
    .title-text__title {
      margin: 0;
      overflow: hidden;
      color: #323233;
      font-size: 16px;
      line-height: 1.375;
      word-break: break-all;
    }
    .title-text__sub-title {
      display: inline-block;
      margin-left: 15px;
      color: #8c8c8c;
      font-size: 12px;
      line-height: 1.375;
      word-break: break-all;
    }
    &.title-text__bottom-slicer::after {
      position: absolute;
      top: 0;
      left: 0;
      box-sizing: border-box;
      width: 200%;
      height: 200%;
      -webkit-transform: scale(.5);
      transform: scale(.5);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0;
      content: "";
      pointer-events: none;
      border-bottom: 1px solid #eee;
    }
    .title-text__more {
      display: flex;
      align-items: center;
      font-size: 12px;
      white-space: nowrap;
      float: right;
      margin-left: 24px;
      .title-text__more-text {
        font-size: 12px;
      }
    }
  }
}
.image-list {
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
  font-size: 0;
  .image-text-nav {
    overflow: hidden;
    font-size: 0;
    &__nav {
      margin-bottom: -10px;
      padding-bottom: 10px;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch;
    }
    &__item {
      display: inline-block;
      overflow: hidden;
      width: 25%;
      height: 50px;
    }
    &__image {
      display: block;
      width: 100%;
      height: 100%;
      border: 0;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}

.goods-preview {
  width: 100%;
  overflow: hidden;
  .goods-preview__list {
    overflow: hidden;
    margin: 0;
    padding: 0;
    &.horizontal {
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      overflow-y: hidden;

      .item-goods {
        border-radius: 10px;
        flex: 0 0 30%;
        float: none;
        width: 30%;
      }
      .info-goods {
        padding: 0 8px 2px;
      }
      .desc-goods {
        display: none;
      }
      .price-goods .price {
        height: 16px;
        font-size: 16px;
        line-height: 16px;
      }
      .buy-btn .van-icon {
        height: 20px;
        font-size: 20px;
        line-height: 20px;
      }
      .badge-goods {
        .van-icon {
          font-size: 28px;
        }
        &.new .van-icon {
          top: 1px;
          &::after {
            top: 10px;
            left: 4px;
            width: 20px;
            height: 10px;
          }
        }
        &.hot .van-icon {
          top: 7px;
          left: 0;
          &::after {
            top: 0;
            left: 7px;
            width: 14px;
            height: 27px;
          }
        }
        &.NEW .van-icon {
          top: 0;
          left: 5px;
          font-size: 32px;
          &::after {
            top: 0;
            left: 7px;
            width: 19px;
            height: 23px;
          }
        }
        &.HOT .van-icon {
          top: 5px;
          left: 5px;
          &::after {
            top: 9px;
            left: 7px;
            width: 16px;
            height: 14px;
          }
        }
      }
    }
    &.vertical {
      .item-goods {
        float: left;
        width: 33.333%;
      }
    }
  }
  .a-item-goods {
    position: relative;
    display: block;
    box-sizing: border-box;
    min-height: 50px;
    overflow: hidden;
    color: #333333;
    background-color: #ffffff;
    transition: all ease .2s;
    border-radius: 8px;
  }
  .item-goods {
    overflow: hidden;
  }
  .image-goods {
    position: relative;
    .image-goods-inner {
      position: relative;
      max-height: 500px;
      overflow: hidden;
      .img-goods {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        background-repeat: no-repeat;
        background-position: 50%;
        &.cover {
          background-size: cover;
        }
        &.contain {
          background-size: contain;
        }
      }
    }
  }
  .info-goods {
    position: relative;
    padding: 0 12px 4px;
    &.align-center {
      .title-goods {
        text-align: center;
      }
      .price-goods {
        flex-direction: column;
        height: auto;
        .price {
          flex-shrink: 0;
          height: 44px;
          line-height: 44px;
        }
        .buy-btn {
          margin-bottom: 10px;
        }
      }
    }
    .name-goods {
      margin-top: 12px;
      max-height: 34px;
      height: 34px;
      line-height: 17px;
      margin-bottom: 4px;
      font-weight: 400;
      color: #323233;
      font-size: 13px;
      vertical-align: middle;
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .desc-goods, .specs-goods {
      height: 16px;
      color: #969799;
      font-size: 14px;
      line-height: 16px;
      word-break: break-all;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }
    .specs-goods {
      color: #9cb945;
      font-size: 12px;
    }
    .price-goods {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price {
        height: 20px;
        color: #f84343;
        font-size: 20px;
        line-height: 20px;
        word-break: break-all;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .currency-price {
        align-self: center;
        height: 14px;
        margin-right: 2px;
        font-size: 14px;
      }
      .original-price {
        color: #909399;
        text-decoration: line-through;
        font-size: 13px;
        margin-left: 10px;
      }
    }
    .buy-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      .van-icon {
        color: #f84343;
        font-size: 24px;
        line-height: normal;
        box-sizing: border-box;
      }
      &.style-4 .buy-text,
      &.style-8 .buy-text {
        color: #f84343;
        border-radius: 2px;
        border: 1px solid #f84343;
        background-color: #ffffff;
      }
      &.style-7 .buy-text {
        border-radius: 2px;
      }
      &.style-8 .buy-text {
        border-radius: 24px;
      }
      .buy-text {
        color: #ffffff;
        background-color: #f84343;
        font-size: 12px;
        height: 24px;
        line-height: normal;
        outline: none;
        border: none;
        border-radius: 24px;
        padding: 0 8px;
        box-sizing: border-box;
        transition: all ease .2s;
      }
      .buy-btn-image {
        width: 20px;
        height: 20px;
      }
    }
  }
  .badge-goods {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    &.new .van-icon {
      top: 11px;
      &::after {
        top: 10px;
        left: 4px;
        width: 28px;
        height: 17px;
      }
    }
    &.hot .van-icon {
      top: 10px;
      left: 5px;
      &::after {
        top: 0;
        left: 10px;
        width: 17px;
        height: 35px;
      }
    }
    &.NEW .van-icon {
      left: 4px;
      &::after {
        top: 0;
        left: 7px;
        width: 13px;
        height: 25px;
      }
    }
    &.HOT .van-icon {
      top: 10px;
      left: 10px;
      &::after {
        top: 9px;
        left: 7px;
        width: 24px;
        height: 22px;
      }
    }
    .van-icon {
      position: relative;
      color: #f84343;
      font-size: 38px;
      line-height: normal;
      &::after {
        content: '';
        position: absolute;
        z-index: -1;
        background-color: #ffffff;
      }
    }
    .image-badge {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      color: #f84343;
      font-size: 12px;
      &.no-image {
        background-color: #86b6cb;
      }
    }
  }
}
</style>
